import { passCodes } from '../passCodes';
import { zdarCustomCiphers } from '../zdarEscapeGameCustomCiphers';
import track28 from '../../../../assets/audio/tracks/track28.mp3';

const hints = [
    {
        text: 'První číslo označuje pořadí textu, druhé číslo označuje pořadí písmene v daném textu.',
    },
    {
        text: 'Text čtěte od konce po začátek.',
    },
    {
        text: 'Kódem jsou: nože',
        solution: true,
    },
];
export const step28butchers = {
    id: 26,
    title: '12. stanoviště',
    taskText: `
        <p>
            Vrať se zpátky k řeznictví a začni luštit, ať víme co dál.
        </p>
    `,
    catImage: 5,
    audio: track28,
    snowAudio: track28,
    cipher: {
        label: 'Úkol',
        custom: zdarCustomCiphers.butcher,
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[19],
    additionalInfo: 'Odpovědí je jedno slovo.',
    hints: hints,
    snowHints: hints,
};
